/**
 * DOMAIN — Use Case: Embaralhamento do deck de reprodução da playlist YouTube
 *
 * Função pura sem dependência do React — testável de forma isolada.
 * O hook `useYoutubePlaylist` (presentation/hooks) usa esta função para
 * gerar a ordem aleatória de reprodução dos itens da playlist.
 */

/** Embaralhamento Fisher-Yates — gera uma ordem aleatória dos índices [0, len). */
export function gerarDeck(len: number): number[] {
  const arr = Array.from({ length: len }, (_, i) => i);
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

/** Deck sequencial: toca do índice atual em ordem crescente (wrap). */
export function gerarDeckSequencial(len: number, indexInicial = 0): { deck: number[]; index: number } {
  if (len <= 0) return { deck: [], index: 0 };
  const start = ((indexInicial % len) + len) % len;
  const deck: number[] = [];
  for (let i = 1; i < len; i++) {
    deck.push((start + i) % len);
  }
  return { deck, index: start };
}
